<template>
  <div class="not-found">
    <div class="content">
      <div>
        <img src="@/assets/404.png" alt />
      </div>
      <div>
        <span>404</span>
        <p>
          很抱歉，您要访问的页面地址有误
          <br />或者该页面不存在
        </p>
        <el-button type="primary" @click="goHome">
          返回首页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { clearMenus } from "@/utils/storeMenu";

const router = useRouter();

const goHome = () => {
  // 移除菜单缓存，重新刷新页面进入
  clearMenus();
  router.replace({ path: "/" });
};
</script>

<style scoped>
.not-found {
  text-align: center;
  height: 100vh;
}
.content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
}
img{
  width: 30vw;
}
.content > div:nth-child(2) {
  padding-left: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}

.not-found span {
  font-size: 70px;
  color: #3d3d3d;
}

.not-found p {
  font-size: 20px;
  color: #3d3d3d;
  text-align: left;
  line-height: 32px;
  margin: 15px 0 20px;
}

.not-found a{
  color: #fff;
  text-decoration: none;
}

.not-found a:hover {
  text-decoration: underline;
}
</style>